// extracted by mini-css-extract-plugin
export default {"textarea":"V0XxSQ"};